// extracted by mini-css-extract-plugin
export var completionBody = "_ed-2";
export var completionCard = "_ed-0";
export var completionFooter = "_ed-3";
export var completionTitle = "_ed-1";